import { trigger } from '@angular/animations';
import { Component } from '@angular/core';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Device, DeviceDTO } from 'src/app/models/DeviceDTO.model';
import { SendSmsRequest } from 'src/app/models/sendSMS/SendSmsRequest';
import { SendsmsService } from 'src/app/services/sendsms.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableControlComponent } from '../../shared/controls/table-control/table-control.component';
import { DeviceApiLogsComponent } from '../../shared/components/device-api-logs/device-api-logs.component';
declare var bootstrap: any;

@Component({
    selector: 'app-send-sms',
    templateUrl: './send-sms.component.html',
    styleUrl: './send-sms.component.css',
    imports: [
        CommonModule,
        FormsModule,
        TableControlComponent,
        DeviceApiLogsComponent
    ]
})

export class SendSMSComponent {

  smsMaxCharacters: number = 160;

  sims: Device[] = [] as Device[];
  filteredSims: Device[] = [] as Device[];
  textoBusqueda: string = '';
  isCheckAllChecked: boolean = false;
  chekedItemsCount: number = 0;
  isAnyCheckBoxInventory: boolean = false;
  shouldClearSelection: boolean = false;

  showDeviceApiLogsModal: boolean = false;

  selectedDevices: DeviceDTO[] = [];
  selectedDevice: DeviceDTO = {};

  smsMessage?: string = '';

  isDisabledSendSms: boolean = true;
  isProcessing: boolean = false;






  constructor(private sendsmsService: SendsmsService,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService
  ) {


  }

  ngOnInit() {
    this.permissionsService.validateAccessLevels(MODULE_ID.SendSMS);




    this.sendsmsService.getDevicesByCustomer().subscribe(
      (data) => {

        this.sims = data;

      },
      (error) => {


        //this.alertService.error(error);
      }
    );

  }

  getColumns() {
    var columns = [
      { key: 'iccid', header: 'ICCID' },
      { key: 'imei', header: 'IMEI' },
      { key: 'mdn', header: 'MDN' },
      { key: 'firstName', header: 'First Name' },
      { key: 'lastName', header: 'Last Name' },
      { key: 'devName', header: 'User Name', width: 200 },
      { key: 'devName2', header: 'User Name 2', width: 200 },
      { key: 'custom1', header: 'Custom 1', width: 200 },
      { key: 'custom2', header: 'Custom 2', width: 200 },
      { key: 'nameStatus', header: 'Status' }
    ];

    if (this.permissionsService.readPermission) {
      columns.unshift({ key: 'nameRatePlan', header: 'Plan', width: 200 });
      columns.unshift({ key: 'nameCustomer', header: 'Customer', width: 200 });
    }

    return columns;
  }

  updateSendSmsButton() {

    if (this.smsMessage && this.smsMessage?.length > 0 && this.selectedDevices.length > 0) {
      this.isDisabledSendSms = false;
    }
    else {
      this.isDisabledSendSms = true;
    }
  }



  actionButtons = [
    { label: 'ShowLogs', class: 'secondary', icon: 'bi bi-clock-history' },

  ];

  onSelectionChange(selectedDevices: DeviceDTO[]): void {
    this.selectedDevices = selectedDevices;
    this.updateSendSmsButton()

  }

  onAction(event: { action: string; item: DeviceDTO }): void {
    console.log(`Action "${event.action}" on:`, event.item);
    // Handle different actions
    switch (event.action) {
      case 'ShowLogs':
        this.selectedDevice = event.item;
        this.showDeviceApiLogsModal = true;

        break;

    }
  }

  sendSMS(): void {
    this.isDisabledSendSms = true;
    this.isProcessing = true;

    if (this.smsMessage && this.selectedDevices.length > 0) {
      const smsRequest: SendSmsRequest = {
        message: this.smsMessage,
        devices: this.selectedDevices.map(item => String(item.iccid))
      };

      this.sendsmsService.sendSMS(smsRequest).subscribe(
        (data) => {


          this.smsMessage = "";

          this.shouldClearSelection = true;

          setTimeout(() => this.shouldClearSelection = false);

          this.alertService.success("Message sent Successfully");

          this.selectedDevices = [];
          this.isDisabledSendSms = true;
          this.isProcessing = false;

        },
        (error) => {
          this.alertService.error(error);

          this.selectedDevices = [];
          this.smsMessage = "";
      
          this.shouldClearSelection = true;
          setTimeout(() => this.shouldClearSelection = false);

          this.isDisabledSendSms = true;
          this.isProcessing = false;
        }
      );

    }





  }

  onDismiss(value: boolean) {
    this.showDeviceApiLogsModal = false;
  }
}
